/* tslint:disable */

import { ActionTargetStep } from './action-target-step';
import { ConditionalTargetStep } from './conditional-target-step';
import { FieldHiddenOption } from './field-hidden-option';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { WorkflowActionDialogOptions } from './workflow-action-dialog-options';
import { WorkflowActionMessage } from './workflow-action-message';
export class WorkflowAction {
  commentRequired?: boolean;
  conditionalTargetSteps?: Array<ConditionalTargetStep>;
  description?: null | NullableLocalizedValue;
  dialogOptions?: WorkflowActionDialogOptions;
  id?: string;
  isMainAction: boolean;
  message?: null | WorkflowActionMessage;
  name: LocalizedValue;
  targetStep: ActionTargetStep;
  visible?: null | FieldHiddenOption;
}
